<template>
    <div>
        <v-navigation-drawer
            v-model="drawer"
            absolute
            temporary>
            <v-list class="pa-0">
                <v-list-tile>
                    <v-list-tile-action></v-list-tile-action>
                    <v-list-tile-content>
                        <router-link to="/">Home</router-link>
                    </v-list-tile-content>
                </v-list-tile>
                <v-list-tile>
                    <v-list-tile-action></v-list-tile-action>
                    <v-list-tile-content>
                        <a href="http://openmpt.org/features">Tracker</a>
                    </v-list-tile-content>
                </v-list-tile>
                <v-list-tile>
                    <v-list-tile-action></v-list-tile-action>
                    <v-list-tile-content>
                        <a href="http://openmpt.org/legacy_software">Player</a>
                    </v-list-tile-content>
                </v-list-tile>
                <v-list-tile>
                    <v-list-tile-action></v-list-tile-action>
                    <v-list-tile-content>
                        <a href="http://resources.openmpt.org/modfaq/">MOD FAQ</a>
                    </v-list-tile-content>
                </v-list-tile>
                <v-list-tile>
                    <v-list-tile-action></v-list-tile-action>
                    <v-list-tile-content>
                        <router-link to="/random-title-generator">Random Title</router-link>
                    </v-list-tile-content>
                </v-list-tile>
                <v-list-tile>
                    <v-list-tile-action></v-list-tile-action>
                    <v-list-tile-content>
                        <a href="http://forum.openmpt.org/">Forums</a>
                    </v-list-tile-content>
                </v-list-tile>
            </v-list>
        </v-navigation-drawer>
        <v-toolbar class="v-toolbar--fixed v-toolbar--clipped elevation-6" app color="primary" role="navigation" title="Primary Navigation">
            <v-toolbar-side-icon class="hidden-sm-and-down">
                <router-link to="/">
                    <img src="@/assets/img/mpclogo-small.png" height="32"/>
                </router-link>
            </v-toolbar-side-icon>
            <v-toolbar-side-icon class="hidden-sm-and-up" @click.stop="drawer = !drawer"></v-toolbar-side-icon>
            <v-toolbar-title>MODPlug Central</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-toolbar-items class="hidden-sm-and-down" role="menubar">
                <v-spacer></v-spacer>
                <v-btn flat to="/" class="font-weight-bold" role="menuitem">
                    Home
                </v-btn>
                <v-btn flat href="http://openmpt.org/features" class="font-weight-bold" role="menuitem">
                    Tracker
                </v-btn>
                <v-btn flat href="http://openmpt.org/legacy_software" class="font-weight-bold" role="menuitem">
                    Player
                </v-btn>
                <v-btn href="http://resources.openmpt.org/modfaq/" flat class="font-weight-bold" role="menuitem">
                    MOD FAQ
                </v-btn>
                <v-btn href="http://forum.openmpt.org/" flat class="font-weight-bold" role="menuitem">
                    MODPlug Forums
                </v-btn>
            </v-toolbar-items>
        </v-toolbar>
    </div>
</template>

<script>
    export default {
        name: "MPCHeader",
        data() {
            return {
                drawer: false
            }
        }
    }
</script>
